import { render, staticRenderFns } from "./returnRecord.vue?vue&type=template&id=7857c86e"
import script from "./returnRecord.vue?vue&type=script&lang=js"
export * from "./returnRecord.vue?vue&type=script&lang=js"
import style0 from "./returnRecord.vue?vue&type=style&index=0&id=7857c86e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports